import React, { useMemo } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { FaEye } from "react-icons/fa";
import { FcInfo } from "react-icons/fc";

const EyeButton = ({ message,placement = "top",size = 16,color = "#6c757d",}) => {
  const tooltipId = useMemo(
    () => `eye-tooltip-${Math.random().toString(36).substring(2, 9)}`,
    []
  );

  return (
    <>
      <span
        id={tooltipId}
        style={{
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          color,
        }}
      >
        <FcInfo size={size} />
      </span>

      <UncontrolledTooltip placement={placement} target={tooltipId}>
        {message}
      </UncontrolledTooltip>
    </>
  );
};

export default EyeButton;